@if (isAllowed()) {
<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="true"
  [resizable]="true"
  [maximizable]="true"
  [style]="{ width: '960px', maxHeight: '85vh' }"
  styleClass="dev-panel-dialog"
  (onHide)="close()">

  <!-- Header -->
  <ng-template pTemplate="header">
    <div class="dev-panel-header">
      <div class="dev-panel-title">
        <span class="dev-badge">DEV</span>
        <span class="ms-2 fw-bold">Panel de Permisos</span>
      </div>
      @if (user(); as u) {
        <div class="dev-user-pill">
          <i class="pi pi-user me-1"></i>
          <span>{{ u.email }}</span>
          @if (isSuperAdmin()) {
            <span class="badge-sa ms-2">SUPER_ADMIN</span>
          } @else {
            <span class="badge-role ms-2">roleId: {{ u.roleId ?? '—' }}</span>
          }
          <span class="badge-biz ms-2">biz: {{ u.businessNameId ?? '—' }}</span>
        </div>
      }
    </div>
  </ng-template>

  <!-- Body -->
  <ng-template pTemplate="content">

    <!-- Filtro global -->
    <div class="dev-filter-bar mb-3">
      <p-iconfield styleClass="flex-1">
        <p-inputicon styleClass="pi pi-search" />
        <input pInputText type="text" [ngModel]="filterText()"
               (ngModelChange)="filterText.set($event)"
               placeholder="Buscar opción, grupo, ruta..."
               class="w-100 dev-filter-input" />
      </p-iconfield>
      @if (!permSvc.isLoaded()) {
        <span class="dev-warn ms-3"><i class="pi pi-exclamation-triangle me-1"></i>Permisos no cargados</span>
      } @else if (isSuperAdmin()) {
        <span class="dev-info ms-3"><i class="pi pi-shield me-1"></i>SUPER_ADMIN · acceso total</span>
      } @else {
        <span class="dev-info ms-3">
          <i class="pi pi-lock-open me-1"></i>
          {{ allowedRoutes() }}/{{ routeMap.length }} rutas con lectura
        </span>
      }
    </div>

    <!-- Tabs PrimeNG 21 -->
    <p-tabs [value]="activeTab()" (valueChange)="activeTab.set($event?.toString() ?? activeTab())">

      <p-tablist>
        <p-tab value="permisos">
          <i class="pi pi-shield me-2"></i>Permisos ({{ filteredRows().length }})
        </p-tab>
        <p-tab value="rutas">
          <i class="pi pi-sitemap me-2"></i>Rutas ({{ routeRows().length }})
        </p-tab>
        <p-tab value="token">
          <i class="pi pi-id-card me-2"></i>Token JWT
        </p-tab>
      </p-tablist>

      <p-tabpanels>

        <!-- ── Tab 1: Permisos por opción ── -->
        <p-tabpanel value="permisos">
          @if (isSuperAdmin()) {
            <div class="dev-superadmin-banner mb-3">
              <i class="pi pi-star-fill me-2"></i>
              SUPER_ADMIN — sin restricciones. Las filas son informativas.
            </div>
          }
          <div class="dev-table-wrapper">
            <table class="dev-table">
              <thead>
                <tr>
                  <th class="col-id">ID</th>
                  <th class="col-opt">Opción</th>
                  <th class="col-grp">Grupo</th>
                  @for (col of actionCols; track col) {
                    <th class="col-act">{{ col }}</th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (row of filteredRows(); track row.optionId) {
                  <tr>
                    <td class="col-id mono">{{ row.optionId }}</td>
                    <td class="col-opt">{{ row.optionName }}</td>
                    <td class="col-grp">{{ row.groupName }}</td>
                    @for (act of row.actions; track $index) {
                      <td class="col-act text-center">
                        @if (act.allow === true) {
                          <span class="act-yes" [pTooltip]="act.name || actionCols[$index]" tooltipPosition="top">
                            <i class="pi pi-check"></i>
                          </span>
                        } @else if (act.allow === false) {
                          <span class="act-no" [pTooltip]="act.name || actionCols[$index]" tooltipPosition="top">
                            <i class="pi pi-times"></i>
                          </span>
                        } @else {
                          <span class="act-na">—</span>
                        }
                      </td>
                    }
                  </tr>
                }
                @empty {
                  <tr>
                    <td [attr.colspan]="3 + actionCols.length" class="text-center text-muted py-4">
                      @if (!permSvc.isLoaded()) {
                        Permisos aún no cargados — navega a una ruta protegida primero.
                      } @else {
                        Sin resultados para "{{ filterText() }}"
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </p-tabpanel>

        <!-- ── Tab 2: Rutas del sistema ── -->
        <p-tabpanel value="rutas">
          <div class="dev-table-wrapper">
            <table class="dev-table">
              <thead>
                <tr>
                  <th class="col-route">Ruta Angular</th>
                  <th class="col-id">OptionId</th>
                  <th class="col-opt">Opción DB</th>
                  <th class="col-access text-center">Lectura</th>
                </tr>
              </thead>
              <tbody>
                @for (row of routeRows(); track row.route) {
                  <tr [class.row-denied]="!row.canRead && !isSuperAdmin()">
                    <td class="col-route mono">/{{ row.route }}</td>
                    <td class="col-id mono">{{ row.optionId }}</td>
                    <td class="col-opt">{{ row.label }}</td>
                    <td class="col-access text-center">
                      @if (isSuperAdmin() || row.canRead) {
                        <span class="act-yes"><i class="pi pi-check"></i></span>
                      } @else {
                        <span class="act-no"><i class="pi pi-times"></i></span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </p-tabpanel>

        <!-- ── Tab 3: Token JWT ── -->
        <p-tabpanel value="token">
          @if (user(); as u) {
            <div class="dev-token-grid">
              <div class="dev-token-row">
                <span class="dev-token-key">sub (userId)</span>
                <span class="dev-token-val mono">{{ u.sub }}</span>
              </div>
              <div class="dev-token-row">
                <span class="dev-token-key">email</span>
                <span class="dev-token-val mono">{{ u.email }}</span>
              </div>
              <div class="dev-token-row">
                <span class="dev-token-key">username</span>
                <span class="dev-token-val mono">{{ u.username ?? '—' }}</span>
              </div>
              <div class="dev-token-row">
                <span class="dev-token-key">roleId</span>
                <span class="dev-token-val mono">{{ u.roleId ?? '—' }}</span>
              </div>
              <div class="dev-token-row">
                <span class="dev-token-key">businessNameId</span>
                <span class="dev-token-val mono">{{ u.businessNameId ?? '—' }}</span>
              </div>
              <div class="dev-token-row">
                <span class="dev-token-key">roles</span>
                <span class="dev-token-val">
                  @for (role of u.roles; track role) {
                    <span class="badge-role me-1">{{ role }}</span>
                  }
                </span>
              </div>
              <div class="dev-token-row">
                <span class="dev-token-key">iat</span>
                <span class="dev-token-val mono">{{ (u.iat * 1000) | date:'yyyy-MM-dd HH:mm:ss' }}</span>
              </div>
              <div class="dev-token-row">
                <span class="dev-token-key">exp</span>
                <span class="dev-token-val mono">{{ (u.exp * 1000) | date:'yyyy-MM-dd HH:mm:ss' }}</span>
              </div>
            </div>
          } @else {
            <p class="text-muted py-3">No hay token activo.</p>
          }
        </p-tabpanel>

      </p-tabpanels>
    </p-tabs>
  </ng-template>

  <!-- Footer -->
  <ng-template pTemplate="footer">
    <div class="dev-panel-footer">
      <span class="dev-shortcut">
        <kbd>{{ isMac() ? '⌘' : 'Ctrl' }}</kbd> + <kbd>Shift</kbd> + <kbd>P</kbd>
      </span>
      <span class="dev-env-badge" [class.dev-env-dev]="isDevEnv()" [class.dev-env-prod]="!isDevEnv()">
        {{ isDevEnv() ? 'DEV MODE' : 'PROD' }}
      </span>
    </div>
  </ng-template>

</p-dialog>
}
